<template>
    <div class="desktop-setting-body">
        <div class="title-container">
            
            <i @click="closeSettings" class="fas fa-arrow-right back-icon"></i>
            <h3 class="title">
                تنظیمات
            </h3>
        </div>
        <div class="body-container">
            <div class="body">
                <div class="flex-shrink-0 d-flex">
                    <ul class="list-unstyled">
                        <li class="mb-1">
                            <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed title-menu" data-bs-toggle="collapse" data-bs-target="#home-collapse" aria-expanded="true">
                            حساب کاربری
                            </button>
                            <form @submit.prevent="updateUser">
                                <div class="collapse show collapse-box" id="home-collapse">
                                    <span class="subtitle-menu">
                                        اطلاعات شخصی
                                    </span>
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <div class="inputBox">
                                                <input type="text" v-model="changedUser.first_name" placeholder=" " class="profile-input" required>
                                                <span>نام</span>
                                            </div>
                                            <div class="inputBox">
                                                <input type="text" v-model="changedUser.last_name" placeholder=" " class="profile-input">
                                                <span>نام خانوادگی</span>
                                            </div>
                                            <div class="inputBox">
                                                <input type="date" v-model="changedUser.birthdate" placeholder=" " class="profile-input">
                                                <span>تاریخ تولد</span>
                                            </div>
                                            <div class="inputBox">
                                                <input type="text" v-model="changedUser.national_id" placeholder=" " class="profile-input">
                                                <span>کد ملی</span>
                                            </div>
                                            <div class="inputBox">
                                                <input type="text" v-model="changedUser.job_title" placeholder=" " class="profile-input">
                                                <span>شغل</span>
                                            </div>
                                        </li>
                                    </ul>
                                    <span class="subtitle-menu">
                                        اطلاعات تماس
                                    </span>
                                    <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li>
                                            <div class="inputBox">
                                                <input style="cursor: not-allowed;" type="number" v-model="changedUser.phone" placeholder=" " class="profile-input" required disabled>
                                                <span>شماره همراه</span>
                                            </div>
                                            <div class="inputBox">
                                                <input type="text" v-model="changedUser.email" placeholder=" " class="profile-input">
                                                <span>ایمیل</span>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="d-grid" style="justify-content: center;">
                                        <button class="subtim-btn" type="submit" :disabled="loading">
                                            <span v-if="loading">در حال ارسال...</span>
                                            <span v-else>ویرایش اطلاعات</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </li>
                        <li class="border-top my-3"></li>
                        <li class="mb-1">
                            <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed title-menu" data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="false">
                            اعلان ها
                            </button>
                            <div class="collapse" id="dashboard-collapse">
                                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small notifs">
                                    <span class="telgram-text">
                                        دریافت پیام از طریق تلگرام
                                    </span>
                                    <label class="switch">
                                        <input
                                            type="checkbox"
                                            v-model="isTelegramEnabled"
                                            @change="handleTelegramChange"
                                        />
                                        <span class="slider"></span>
                                    </label>
                                </ul>
                            </div>
                        </li>
                        <li class="border-top my-3"></li>
                        <li class="mb-1">
                            <button class="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed title-menu" data-bs-toggle="collapse" data-bs-target="#orders-collapse" aria-expanded="false">
                            نمای ظاهری
                            </button>
                            <!-- <div class="collapse" id="orders-collapse">
                                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                    <li><a href="#" class="link-body-emphasis d-inline-flex text-decoration-none rounded">New</a></li>
                                    <li><a href="#" class="link-body-emphasis d-inline-flex text-decoration-none rounded">Processed</a></li>
                                    <li><a href="#" class="link-body-emphasis d-inline-flex text-decoration-none rounded">Shipped</a></li>
                                    <li><a href="#" class="link-body-emphasis d-inline-flex text-decoration-none rounded">Returned</a></li>
                                </ul>
                            </div> -->
                        </li>
                    </ul>
                </div>
            </div>
            
        </div>
    </div>
</template>


<script>
import { inject, ref } from 'vue';
import axios from 'axios';

export default {
    name: 'DesktopSetting',
    setup() {
        const user = inject('user');
        const changedUser = ref({});
        const loading = ref(false);

        const isTelegramEnabled = ref(false);

        const formatDateForInput = (dateString) => {
            if (!dateString) return null; // اگر تاریخ موجود نباشد
            const date = new Date(dateString);
            return date.toISOString().split('T')[0]; // تبدیل به فرمت YYYY-MM-DD
        };

        return { user, changedUser, formatDateForInput, loading, isTelegramEnabled };
    },
    watch: {
        user(newValue) {
            if (newValue) {
                // کپی مقدار `user` به `changedUser`
                this.changedUser = { ...newValue,
                    birthdate: this.formatDateForInput(newValue.birthdate),
                };
                this.isTelegramEnabled = Boolean(newValue.telegram_id);
            }
        },
    },
    methods: {
        closeSettings() {
            this.$emit('closeSettings');
        },
        async updateUser() {
            this.loading = true;
            try {
                const token = localStorage.getItem('token');
                const allowedFields = ['first_name', 'last_name', 'birthdate', 'national_id', 'job_title', 'email'];
                const filteredUser = Object.keys(this.changedUser)
                    .filter(key => allowedFields.includes(key))
                    .reduce((obj, key) => {
                        obj[key] = this.changedUser[key];
                        return obj;
                    }, {});
                const response = await axios.patch(`https://api.noticapp.ir/v1/users/${this.user.id}`, filteredUser, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status === 200) {
                    this.$emit('closeSettings');
                }
            } catch (error) {
                console.log(error.response.data.message);
            } finally {
                this.loading = false;
            }
        },
        updateDate(event) {
            this.changedUser.birthdate = event.target.value;
        },
        handleTelegramChange() {
            if (this.isTelegramEnabled) {
                // باز کردن صفحه فعال‌سازی تلگرام در تب جدید
                window.open(`https://t.me/NoticappBot?start=set_${this.user.uuid}`, '_blank');
            } else {
                // باز کردن صفحه غیرفعال‌سازی تلگرام در تب جدید
                window.open(`https://t.me/NoticappBot?start=remove_${this.user.uuid}`, '_blank');
            }
        },
    }
};
</script>


<style scoped>
    /* Bootstrap Accordion Start */
        /* body {
        min-height: 100vh;
        min-height: -webkit-fill-available;
        } */

        /* html {
        height: -webkit-fill-available;
        } */

        /* main {
        height: 100vh;
        height: -webkit-fill-available;
        max-height: 100vh;
        overflow-x: auto;
        overflow-y: hidden;
        } */

        /* .dropdown-toggle { outline: 0; } */

        /* .btn-toggle {
        padding: .25rem .5rem;
        font-weight: 600;
        color: var(--bs-emphasis-color);
        background-color: transparent;
        } */
        /* .btn-toggle:hover,
        .btn-toggle:focus {
        color: rgba(var(--bs-emphasis-color-rgb), .85);
        background-color: var(--bs-tertiary-bg);
        } */

        .btn-toggle::after {
        width: 1.25em;
        line-height: 0;
        content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%28255,255,255,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
        transition: transform .35s ease;
        transform-origin: .5em 50%;
        transform: rotate(180deg);
        }

        /* [data-bs-theme="dark"] .btn-toggle::before {
        content: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%28255,255,255,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e");
        } */

        /* .btn-toggle[aria-expanded="true"] {
        color: rgba(var(--bs-emphasis-color-rgb), .85);
        } */
        .btn-toggle[aria-expanded="true"]::after {
        transform: rotate(90deg);
        }

        .btn-toggle-nav a {
        padding: .1875rem .5rem;
        margin-top: .125rem;
        margin-left: 1.25rem;
        }
        /* .btn-toggle-nav a:hover,
        .btn-toggle-nav a:focus {
        background-color: var(--bs-tertiary-bg);
        } */

        /* .scrollarea {
        overflow-y: auto;
        } */

    /* Bootstrap Accordion End*/


    .desktop-setting-body {
        display: flex;
        flex-direction: column;
        /* align-items: center; */
        height: 100vh;
        background-color: #25292E;
        width: 400px;
    }

    .title-container {
        font-size: 2rem;
        font-weight: bold;
        height: 115px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        z-index: 10;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: end;
    }

    .back-icon {
        font-size: 30px;
        color: white;
        cursor: pointer;
        margin: 0 10px;
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;
    }

    .title {
        color: white;
        font-size: 32px;
        font-weight: bold;
        text-align: center;
        margin-right: 20px;
        margin-bottom: 10px;
    }

    .body-container {
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        /* justify-content: center; */
        /* align-items: center; */
        padding-left: 5px;
    }

    .body-container::-webkit-scrollbar {
        width: 5px;
    }
    .body-container::-webkit-scrollbar-track {
        background: transparent;
    }
    .body-container::-webkit-scrollbar-thumb {
        background: transparent;
        border-radius: 10px;
    }

    .body-container:hover::-webkit-scrollbar-thumb {
        background: #028D92;
    }

    .body-container:hover::-webkit-scrollbar-track {
        background: #1B1E23;
    }

    .title-menu {
        color: white;
        font-size: 19px;
        /* font-weight: bold; */
        /* text-align: center; */
        margin-right: 20px;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .subtitle-menu {
        color: white;
        font-size: 17px;
        margin-right: 0;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .list-unstyled {
        padding-right: 0;
        list-style: none;
        width: 100% !important;
    }

    .show{
        padding: 10px;
        width: 400px;
        display: flex;
        flex-direction: column;
        margin-top: -20px;
        transition: all 0.3s ease;
    }

    /* .collapse-box {
        padding: 10px;
    } */


    li.mb-1 {
        margin-bottom: 0 !important;
        /*go to right*/
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    /* .profile-input {
        background-color: #1B1E23;
        border: none;
        color: white;
        padding: 8px 15px;
        margin-right: auto 10px;
        margin-bottom: 10px;
        width: 100%;
        border-radius: 10px;
    } */

    /* .profile-input::placeholder {
        color: #888;
    } */

    .inputBox {
        position: relative;
        direction: rtl;
    }

    .inputBox input {
        padding: 10px 15px;
        outline: none;
        background: transparent;
        border-radius: 10px;
        color: #fff;
        border: 1px solid #028D92;
        font-size: 1em;
        margin-bottom: 25px;
        letter-spacing: normal;
        width: 100%;;
    }

    .inputBox span {
        position: absolute;
        right: 0;
        padding: 8px 15px;
        pointer-events: none;
        font-size: 15px;
        transition: 0.4s cubic-bezier(0.05, 0.81, 0, 0.93);
        color: #888;
        letter-spacing: normal;
    }

    .inputBox input:focus ~ span,
    .inputBox input:not(:placeholder-shown) ~ span {
        font-size: 15px;
        transform: translateX(-10px) translateY(-20px);
        padding: 0 5px;
        border-radius: 10px;
        background: #26292e;
        letter-spacing: normal;
        border: 1px solid #028D92;
    }

    .inputBox input[type="date"]:focus ~ span,
    .inputBox input[type="date"]:not(:placeholder-shown) ~ span {
        font-size: 15px;
        transform: translateX(-10px) translateY(-20px);
        padding: 0 5px;
        border-radius: 10px;
        background: #26292e;
        letter-spacing: normal;
        border: 1px solid #028D92;
    }

    .subtim-btn {
        background-color: #028D92;
        color: white;
        border: none;
        border-radius: 20px;
        padding: 5px 10px;
        font-size: 18px;
        cursor: pointer;
        width: max-content;
        transition: background-color 0.3s ease;
    }

    .subtim-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .subtim-btn:hover {
        background-color: #1B1E23;
    }


        /* From Uiverse.io by OfficialRedx09 */ 
    /* The switch - the box around the slider */
    .switch {
    font-size: 17px;
    position: relative;
    display: inline-block;
    width: 3.5em;
    height: 2em;
    }

    /* Hide default HTML checkbox */
    .switch input {
    opacity: 0;
    width: 0;
    height: 0;
    }

    /* The slider */
    .slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    border: 2px solid #383838;
    border-radius: 50px;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    .slider:before {
    position: absolute;
    content: "";
    height: 1.4em;
    width: 1.4em;
    right: 0.2em;
    bottom: 0.2em;
    background-color: #999999;
    border-radius: inherit;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
    }

    .switch input:checked + .slider {
    box-shadow: 0 0 5px #028D92;
    border: 2px solid #028D92;
    }

    .switch input:checked + .slider:before {
    transform: translateX(-1.5em);
    background-color: #cc0066;
    }

    .notifs {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .telgram-text {
        color: #fff;
    }

</style>